module.exports = __webpack_public_path__ + "img/pagarme.29f9738a.png";